import MainLayout from "src/layouts/MainLayout.vue";
// Pages en chargement différé : chacune dans son propre fichier, pré-caché par le service worker ;
// une mise à jour ne retélécharge que les fichiers modifiés. Layout et connexion restent dans le bundle principal.

const Error404Page = () => import("src/pages/error404.vue");
import LoginPage from "src/pages/login.vue";
const DashBoardPage = () => import("src/pages/dashBoard.vue");

const UserManagement = () => import("src/pages/userManagement.vue");
const UserGrid = () => import("src/pages/userGrid.vue");
const UserDetail = () => import("src/pages/userDetail.vue");

const SyncManagement = () => import("src/pages/syncManagement.vue");

const PropertyManagement = () => import("src/pages/propertyManagement.vue");
const PropertyGroupGrid = () => import("src/pages/propertyGroupGrid.vue");

const CheckManagement = () => import("src/pages/checkManagement.vue");
const CheckGrid = () => import("src/pages/checkGrid.vue");
const CheckDetail = () => import("src/pages/checkDetail.vue");

const ModelManagement = () => import("src/pages/modelManagement.vue");
const ModelGroupGrid = () => import("src/pages/modelGroupGrid.vue");

const PlantManagement = () => import("src/pages/plantManagement.vue");
const PlantGrid = () => import("src/pages/plantGrid.vue");
const PlantDetail = () => import("src/pages/plantDetail.vue");

const OilManagement = () => import("src/pages/oilManagement.vue");
const OilGrid = () => import("src/pages/oilGrid.vue");
const OilDetail = () => import("src/pages/oilDetail.vue");

const VegetableManagement = () => import("src/pages/vegetableManagement.vue");
const VegetableGrid = () => import("src/pages/vegetableGrid.vue");
const VegetableDetail = () => import("src/pages/vegetableDetail.vue");

const BourgeonManagement = () => import("src/pages/bourgeonManagement.vue");
const BourgeonGrid = () => import("src/pages/bourgeonGrid.vue");
const BourgeonDetail = () => import("src/pages/bourgeonDetail.vue");

const AdditionalManagement = () => import("src/pages/additionalManagement.vue");
const AdditionalGrid = () => import("src/pages/additionalGrid.vue");
const AdditionalDetail = () => import("src/pages/additionalDetail.vue");

const HydrolatManagement = () => import("src/pages/hydrolatManagement.vue");
const HydrolatGrid = () => import("src/pages/hydrolatGrid.vue");
const HydrolatDetail = () => import("src/pages/hydrolatDetail.vue");

const SystemManagement = () => import("src/pages/systemManagement.vue");
const SystemGrid = () => import("src/pages/systemGrid.vue");
const SystemDetail = () => import("src/pages/systemDetail.vue");

const GardenManagement = () => import("src/pages/gardenManagement.vue");
const GardenGrid = () => import("src/pages/gardenGrid.vue");
const GardenDetail = () => import("src/pages/gardenDetail.vue");

const PhytoManagement = () => import("src/pages/phytoManagement.vue");
const PhytoGrid = () => import("src/pages/phytoGrid.vue");
const PhytoDetail = () => import("src/pages/phytoDetail.vue");

const AromaManagement = () => import("src/pages/aromaManagement.vue");
const AromaGrid = () => import("src/pages/aromaGrid.vue");
const AromaDetail = () => import("src/pages/aromaDetail.vue");

const HuiloManagement = () => import("src/pages/huiloManagement.vue");
const HuiloGrid = () => import("src/pages/huiloGrid.vue");
const HuiloDetail = () => import("src/pages/huiloDetail.vue");

const GemmoManagement = () => import("src/pages/gemmoManagement.vue");
const GemmoGrid = () => import("src/pages/gemmoGrid.vue");
const GemmoDetail = () => import("src/pages/gemmoDetail.vue");

const MixManagement = () => import("src/pages/mixManagement.vue");
const MixGrid = () => import("src/pages/mixGrid.vue");
const MixDetail = () => import("src/pages/mixDetail.vue");

const DiagnosticManagement = () => import("src/pages/diagnosticManagement.vue");
const DiagnosticGrid = () => import("src/pages/diagnosticGrid.vue");
const DiagnosticDetail = () => import("src/pages/diagnosticDetail.vue");

const PatientManagement = () => import("src/pages/patientManagement.vue");
const PatientGrid = () => import("src/pages/patientGrid.vue");
const PatientDetail = () => import("src/pages/patientDetail.vue");

const AdviceManagement = () => import("src/pages/adviceManagement.vue");
const AdviceListPage = () => import("src/pages/adviceListPage.vue");
const AdviceEditorPage = () => import("src/pages/adviceEditorPage.vue");

const SettingsManagement = () => import("src/pages/settingsManagement.vue");
const PriceDashboard = () => import("src/pages/priceDashboard.vue");

const SettingManagement = () => import("../pages/setting/settingManagement.vue");
const SettingGrid = () => import("../pages/setting/settingGrid.vue");
const SyncPage = () => import("../pages/syncPage.vue");

const DataQualityManagement = () => import("src/pages/dataQualityManagement.vue");
const DataQualityPage = () => import("src/pages/dataQualityPage.vue");
const DataQualityRecordsPage = () => import("src/pages/dataQualityRecordsPage.vue");
const TemplatePage = () => import("src/pages/templatePage.vue");

const routes = [
  { path: "/Login", component: LoginPage },
  {
    path: "/",
    redirect: '/DashBoard',
    component: MainLayout,
    children: [
      { path: "/DashBoard", name:"dashboard", component: DashBoardPage },
      {
        path: "/SettingsManagement",
        component: SettingsManagement,
      },
      // Prix des thèques et des thérapies (outils de prix activés sur la fiche utilisateur)
      {
        path: "/PriceManagement",
        name: "price-dashboard",
        component: PriceDashboard,
      },
      {
        path: "/UserManagement",
        component: UserManagement,
        children: [
          {
            path: "",
            name: "user-grid",
            component: UserGrid
          },
          {
            path: "/UserManagement/detail/:id",
            name: "user-detail",
            component: UserDetail
          }
        ]
      },
      {
        path: "/PropertyManagement",
        component: PropertyManagement,
        children: [
          {
            path: "",
            name: "property-group-grid",
            component: PropertyGroupGrid
          }
        ]
      },
      {
        path: "/SyncManagement",
        component: SyncManagement,
        children: [
          {
            path: "",
            name: "sync-page",
            component: SyncPage
          }
        ]
      },
      {
        path: "/DataQualityManagement",
        component: DataQualityManagement,
        children: [
          {
            path: "",
            name: "data-quality-grid",
            component: DataQualityPage
          },
          {
            path: "/DataQualityManagement/list/:code",
            name: "data-quality-records",
            component: DataQualityRecordsPage
          }
        ]
      },
      {
        path: "/TemplateManagement",
        name: "template-page",
        component: TemplatePage
      },
      {
        path: "/ModelManagement",
        component: ModelManagement,
        children: [
          {
            path: "",
            name: "model-group-grid",
            component: ModelGroupGrid
          }
        ]
      },
      {
        path: "/setting",
        component: SettingManagement,
        children: [
          {
            path: "",
            name: "setting-grid",
            component: SettingGrid
          }
        ]
      },

      {
        path: "/PlantManagement",
        component: PlantManagement,
        children: [
          {
            path: "",
            name: "plant-grid",
            component: PlantGrid
          },
          {
            path: "/PlantManagement/detail/:id",
            name: "plant-detail",
            component: PlantDetail
          }
        ]
      },
      {
        path: "/SystemManagement",
        component: SystemManagement,
        children: [
          {
            path: "",
            name: "system-grid",
            component: SystemGrid
          },
          {
            path: "/SystemManagement/detail/:id",
            name: "system-detail",
            component: SystemDetail
          }
        ]
      },
      {
        path: "/GardenManagement",
        component: GardenManagement,
        children: [
          {
            path: "",
            name: "garden-grid",
            component: GardenGrid
          },
          {
            path: "/GardenManagement/detail/:id",
            name: "garden-detail",
            component: GardenDetail
          }
        ]
      },
      {
        path: "/OilManagement",
        component: OilManagement,
        children: [
          {
            path: "",
            name: "oil-grid",
            component: OilGrid
          },
          {
            path: "/OilManagement/detail/:id",
            name: "oil-detail",
            component: OilDetail
          }
        ]
      },
      {
        path: "/VegetableManagement",
        component: VegetableManagement,
        children: [
          {
            path: "",
            name: "vegetable-grid",
            component: VegetableGrid
          },
          {
            path: "/VegetableManagement/detail/:id",
            name: "vegetable-detail",
            component: VegetableDetail
          }
        ]
      },
      {
        path: "/BourgeonManagement",
        component: BourgeonManagement,
        children: [
          {
            path: "",
            name: "bourgeon-grid",
            component: BourgeonGrid
          },
          {
            path: "/BourgeonManagement/detail/:id",
            name: "bourgeon-detail",
            component: BourgeonDetail
          }
        ]
      },
      {
        path: "/AdditionalManagement",
        component: AdditionalManagement,
        children: [
          {
            path: "",
            name: "additional-grid",
            component: AdditionalGrid
          },
          {
            path: "/AdditionalManagement/detail/:id",
            name: "additional-detail",
            component: AdditionalDetail
          }
        ]
      },
      {
        path: "/HydrolatManagement",
        component: HydrolatManagement,
        children: [
          {
            path: "",
            name: "hydrolat-grid",
            component: HydrolatGrid
          },
          {
            path: "/HydrolatManagement/detail/:id",
            name: "hydrolat-detail",
            component: HydrolatDetail
          }
        ]
      },
      {
        path: "/PhytoManagement",
        component: PhytoManagement,
        children: [
          {
            path: "",
            name: "phyto-grid",
            component: PhytoGrid
          },
          {
            path: "/PhytoManagement/detail/:id",
            name: "phyto-detail",
            component: PhytoDetail
          }
        ]
      },
      {
        path: "/AromaManagement",
        component: AromaManagement,
        children: [
          {
            path: "",
            name: "aroma-grid",
            component: AromaGrid
          },
          {
            path: "/AromaManagement/detail/:id",
            name: "aroma-detail",
            component: AromaDetail
          }
        ]
      },
      {
        path: "/HuiloManagement",
        component: HuiloManagement,
        children: [
          {
            path: "",
            name: "huilo-grid",
            component: HuiloGrid
          },
          {
            path: "/HuiloManagement/detail/:id",
            name: "huilo-detail",
            component: HuiloDetail
          }
        ]
      },
      {
        path: "/GemmoManagement",
        component: GemmoManagement,
        children: [
          {
            path: "",
            name: "gemmo-grid",
            component: GemmoGrid
          },
          {
            path: "/GemmoManagement/detail/:id",
            name: "gemmo-detail",
            component: GemmoDetail
          }
        ]
      },
      {
        path: "/MixManagement",
        component: MixManagement,
        children: [
          {
            path: "",
            name: "mix-grid",
            component: MixGrid
          },
          {
            path: "/MixManagement/detail/:id",
            name: "mix-detail",
            component: MixDetail
          }
        ]
      },
      {
        path: "/DiagnosticManagement",
        component: DiagnosticManagement,
        children: [
          {
            path: "",
            name: "diagnostic-grid",
            component: DiagnosticGrid
          },
          {
            path: "/DiagnosticManagement/detail/:id",
            name: "diagnostic-detail",
            component: DiagnosticDetail
          }
        ]
      },
      {
        path: "/PatientManagement",
        component: PatientManagement,
        children: [
          {
            path: "",
            name: "patient-grid",
            component: PatientGrid
          },
          {
            path: "/PatientManagement/detail/:id",
            name: "patient-detail",
            component: PatientDetail
          }
        ]
      },
      {
        path: "/AdviceManagement",
        component: AdviceManagement,
        children: [
          {
            path: "",
            name: "advice-grid",
            component: AdviceListPage
          },
          {
            path: "/AdviceManagement/edit/:id",
            name: "advice-editor",
            component: AdviceEditorPage
          }
        ]
      },
      {
        path: "/CheckManagement",
        component: CheckManagement,
        children: [
          {
            path: "",
            name: "check-grid",
            component: CheckGrid
          },
          {
            path: "/CheckManagement/detail/:id",
            name: "check-detail",
            component: CheckDetail
          }
        ]
      },
      // Always leave this as last one,
      // but you can also remove it
      {
        path: '/:catchAll(.*)*',
        component: Error404Page
      }
    ]
  }
]

export default routes;
